import {
  CreateOrderItemEntity,
  OrderItemEntity,
} from '@/pages/privatePages/orderitem/types';
import { BaseService } from './base.service';

class OrderItemService extends BaseService<
  'orderItem',
  OrderItemEntity,
  CreateOrderItemEntity
> {
  constructor() {
    super('products/orders');
  }
}
export const orderItemService = new OrderItemService();
